import { Box, Stack, Text, useBreakpointValue } from '@chakra-ui/react';
import { BannerWrapper, Overline } from '@time-line/components/common';
import { SubscribeWizard } from 'components/subscribe/SubscribeWizard';
import { useIsDarkTheme } from 'hooks/useIsDarkMode';
import type { SignupBanner as SignupBannerType } from 'types/cms/blocks';

export function SignupBanner({
  _key,
  overline,
  title,
  subtitle,
  media,
  isForceWhiteText = false,
  klaviyoListId,
  consentCapture,
  ctaTitle,
}: SignupBannerType) {
  const overlayColor = media?.overlayColor?.hex;
  const isMobile = useBreakpointValue(
    { base: true, lg: false },
    { fallback: 'lg' },
  );
  const isDarkMode = useIsDarkTheme({ color: overlayColor });
  const colorScheme =
    (!isMobile && isForceWhiteText) || isDarkMode ? 'white' : 'gray';
  const textColor = colorScheme === 'white' ? 'gray.50' : 'gray.600';

  return (
    <BannerWrapper id={_key} media={media} isContentFlipped>
      <Stack
        h="100%"
        justifyContent="center"
        textAlign={{ base: 'center', lg: 'left' }}
        alignItems={{ base: 'center', lg: 'start' }}
        pt={{ base: 'm', lg: 0 }}
        pb={{ base: 'lg', lg: 0 }}
        spacing={0}
      >
        {overline && <Overline {...overline} color={textColor} mb="3xs" />}
        <Text as="h2" size="h2" color={textColor}>
          {title}
        </Text>
        {subtitle && (
          <Text
            size="body-serif"
            mt={{ base: '3xs', lg: '2xs' }}
            color={textColor}
          >
            {subtitle}
          </Text>
        )}
        <Box w="full" mt="m">
          <SubscribeWizard
            buttonColorScheme={colorScheme}
            colorScheme={colorScheme}
            consentType={consentCapture?.variant || 'email'}
            autoSubscribeMarketing={consentCapture?.autoSubscribeMarketing}
            klaviyoListId={klaviyoListId}
            ctaTitle={ctaTitle}
          />
        </Box>
      </Stack>
    </BannerWrapper>
  );
}
